<template>
  <div id="app">
    <header>
      <nav class="navbar navbar-dark bg-primary fixed-top">
        <div class="navbar-brand">
          <div class="row d-none d-md-block">
            <div class="col-12">第一学習社 新課程オンラインセミナー 申込 <entry-force /></div>
          </div>
          <div class="row d-block d-md-none">
            <div class="col-6">第一学習社</div>
            <div class="col-6">新課程オンラインセミナー 申込 <entry-force /></div>
          </div>
        </div>
      </nav>
    </header>
    <keep-alive>
      <router-view/>
    </keep-alive>
    <footer class="fixed-bottom">
      <div class="row">
        <div class="col-12 col-md-6">
          <b-button size="sm" variant="link" v-b-modal.modal-contract-footer>特定商取引法に基づく表記</b-button>
        </div>
        <div class="col-12 col-md-6">
          <p>&copy; 2020 DaiichiGakushusha</p>
        </div>
      </div>
    </footer>
    <b-modal id="modal-contract-footer" size="xl" title="特定商取引法に基づく表記" ok-only>
      <contract />
    </b-modal>
  </div>
</template>

<style lang="scss">
#app {
  padding-bottom: 5em;

  header {
    @media screen and (min-width:768px) {
      margin-bottom: 5.0em;
    }
    @media screen and (max-width:767px) {
      margin-bottom: 7.0em;
    }
  }

  footer {
    background-color: #ddd;
    color: rgb(51, 51, 51);
    text-align: center;
    @media screen and (min-width:768px) {
      line-height: 3em;
      height: 3em;
    }
    @media screen and (max-width:767px) {
      line-height: 2.5em;
      height: 5em;
    }
  }

  .bg-primary {
    background-color: #040074 !important;
  }
}

.group {
  margin-bottom: 2.0em;
}

@media screen and (min-width:571px) {
  .pcnone{
    display: none;
  }
}

@media screen and (max-width:570px) {
  h1{
    font-size: 2.0em;
  }
  h2{
    font-size: 1.8em;
  }
  .group{
    width: 100%;
  }
  .spnone{
    display: none;
  }
}

div.note {
  margin-left: 1em;
  text-indent: -1em;
}

#to-page-top {
  position: fixed;
  right: 20px;
  font-size: 80%;
  z-index: 2000;
}

#to-page-top a {
  background: rgba(93, 116, 152, 0.803);
  text-decoration: none;
  color: #fff;
  padding: 10px 15px;
  text-align: center;
  display: block;
  border-radius: 10px;
}

#to-page-top a:hover {
  text-decoration: none;
  background: rgba(0, 60, 151, 0.803);
}

</style>

<script>
import EntryForce from '@/components/EntryForce.vue'
import Contract from'@/components/Contract.vue'
import toTop from '@/to_top'

export default {
  components: {
    EntryForce,
    Contract
  },
  mounted() {
    this.$store.dispatch("initialize")
    toTop()
  }
}
</script>
